module.exports = __webpack_public_path__ + "img/toilet.bf46317a.svg";